import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store from './store/AppStore';
import GraphicsLibraryContainer from './containers/GraphicsLibraryContainer';
import { SnackbarProvider } from 'notistack';
import KapinuaColorsContainer from './containers/KapinuaColorsContainer';
import BuyDialogContainer from './containers/BuyDialogContainer';

import GlobalTheme from './themes/GlobalTheme';
import { MuiThemeProvider } from '@material-ui/core';
import ChangeStyleDialogContainer from './containers/ChangeStyleDialogContainer';
import SaveContainer from './containers/SaveContainer';
import DesignNameContainer from './containers/DesignNameContainer';
import TeamContainer from './containers/TeamContainer';
import MenuContainer from './containers/MenuContainer';
import './localization/init';
import ChangeGraphicColorDialogContainer from './containers/ChangeGraphicColorDialogContainer';

const GraphicsLibraryComponent = (props: any) => {
    const { onInsertGraphicFuncName, currentDesignId, customerId, guestId } =
        props;

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <SnackbarProvider
                    maxSnack={4}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <GraphicsLibraryContainer
                        onInsertGraphicFuncName={onInsertGraphicFuncName}
                        currentDesignId={currentDesignId}
                        customerId={customerId}
                        guestId={guestId}
                    />
                </SnackbarProvider>
            </MuiThemeProvider>
        </Provider>
    );
};

const GraphicsLibraryElement = document.getElementById(
    'kapinua-graphic-library'
);
if (GraphicsLibraryElement !== null) {
    ReactDOM.render(
        React.createElement(GraphicsLibraryComponent, {
            onInsertGraphicFuncName:
                GraphicsLibraryElement.dataset.oninsertgraphicfuncname,
            currentDesignId: GraphicsLibraryElement.dataset.currentdesignid,
            customerId: GraphicsLibraryElement.dataset.customeroverride
                ? Number(GraphicsLibraryElement.dataset.customeroverride)
                : null,
            guestId: GraphicsLibraryElement.dataset.guestoverride
                ? Number(GraphicsLibraryElement.dataset.guestoverride)
                : null,
        }),
        GraphicsLibraryElement
    );
}

const KapinuaColorsComponent = (props: any) => {
    const { onChangeFuncName, activeColor } = props;
    return (
        <Provider store={store}>
            <KapinuaColorsContainer
                onChangeFuncName={onChangeFuncName}
                activeColor={activeColor}
            />
        </Provider>
    );
};

const KapinuaColorElement = document.getElementById('kapinua-color');
if (KapinuaColorElement !== null) {
    ReactDOM.render(
        React.createElement(KapinuaColorsComponent, {
            onChangeFuncName: KapinuaColorElement.dataset.onchangefuncname,
            activeColor: KapinuaColorElement.dataset.activecolor,
        }),
        KapinuaColorElement
    );
}

const BuyDialogComponent = (props: any) => {
    const {
        onSubmitFuncName,
        sizeImg,
        proofServiceLink,
        customerId,
        guestId,
        admin,
    } = props;

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <BuyDialogContainer
                    onSubmitFuncName={onSubmitFuncName}
                    sizeImg={sizeImg}
                    proofServiceLink={proofServiceLink}
                    customerId={customerId}
                    guestId={guestId}
                    admin={admin}
                />
            </MuiThemeProvider>
        </Provider>
    );
};

const BuyDialogElement = document.getElementById('kapinua-buy-dialog');
if (BuyDialogElement !== null) {
    ReactDOM.render(
        React.createElement(BuyDialogComponent, {
            onSubmitFuncName: BuyDialogElement.dataset.onsubmitfuncname,
            sizeImg: BuyDialogElement.dataset.sizeimg,
            proofServiceLink: BuyDialogElement.dataset.proofservicelink,
            customerId: BuyDialogElement.dataset.customeroverride
                ? Number(BuyDialogElement.dataset.customeroverride)
                : null,
            guestId: BuyDialogElement.dataset.guestoverride
                ? Number(BuyDialogElement.dataset.guestoverride)
                : null,
            admin: BuyDialogElement.dataset.admin
                ? Boolean(!!Number(BuyDialogElement.dataset.admin))
                : false,
        }),
        BuyDialogElement
    );
}

const DesignNameComponent = (props: any) => {
    const { customerId, guestId } = props;

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <DesignNameContainer
                    customerId={customerId}
                    guestId={guestId}
                />
            </MuiThemeProvider>
        </Provider>
    );
};

const DesignNameElement = document.getElementById('kapinua-design-name-dialog');
if (DesignNameElement !== null) {
    ReactDOM.render(
        React.createElement(DesignNameComponent, {
            customerId: DesignNameElement.dataset.customeroverride
                ? Number(DesignNameElement.dataset.customeroverride)
                : null,
            guestId: DesignNameElement.dataset.guestoverride
                ? Number(DesignNameElement.dataset.guestoverride)
                : null,
        }),
        DesignNameElement
    );
}

const MenuComponent = (props: any) => {
    const { admin } = props;
    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <MenuContainer admin={admin} />
            </MuiThemeProvider>
        </Provider>
    );
};

const MenuElement = document.getElementById('kapinua-menu');
if (MenuElement !== null) {
    ReactDOM.render(
        React.createElement(MenuComponent, {
            admin: MenuElement.dataset.admin
                ? Boolean(!!Number(MenuElement.dataset.admin))
                : false,
        }),
        MenuElement
    );
}

const TeamComponent = (props: any) => {
    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <TeamContainer />
            </MuiThemeProvider>
        </Provider>
    );
};

const TeamElement = document.getElementById('kapinua-team-dialog');
if (TeamElement !== null) {
    ReactDOM.render(React.createElement(TeamComponent, {}), TeamElement);
}

const SaveDesignComponent = (props: any) => {
    const { customerId, guestId } = props;

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <SnackbarProvider
                    maxSnack={4}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <SaveContainer customerId={customerId} guestId={guestId} />
                </SnackbarProvider>
            </MuiThemeProvider>
        </Provider>
    );
};

const SaveDesignElement = document.getElementById('kapinua-save-design');
if (SaveDesignElement !== null) {
    ReactDOM.render(
        React.createElement(SaveDesignComponent, {
            customerId: SaveDesignElement.dataset.customeroverride
                ? Number(SaveDesignElement.dataset.customeroverride)
                : null,
            guestId: SaveDesignElement.dataset.guestoverride
                ? Number(SaveDesignElement.dataset.guestoverride)
                : null,
        }),
        SaveDesignElement
    );
}

const ChangeStyleDialogComponent = (props: any) => {
    const { onSubmitFuncName, currentGarmentId, currentCategoryId } = props;

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <ChangeStyleDialogContainer
                    onSubmitFuncName={onSubmitFuncName}
                    currentGarmentId={currentGarmentId}
                    currentCategoryId={currentCategoryId}
                />
            </MuiThemeProvider>
        </Provider>
    );
};

const ChangeStyleDialogElement = document.getElementById(
    'kapinua-change-style-dialog'
);
if (ChangeStyleDialogElement !== null) {
    ReactDOM.render(
        React.createElement(ChangeStyleDialogComponent, {
            onSubmitFuncName: ChangeStyleDialogElement.dataset.onsubmitfuncname,
            currentGarmentId: parseInt(
                ChangeStyleDialogElement.dataset.currentgarmentid ?? '0'
            ),
            currentCategoryId: parseInt(
                ChangeStyleDialogElement.dataset.currentcategoryid ?? '0'
            ),
        }),
        ChangeStyleDialogElement
    );
}

const ChangeGraphicColorDialogComponent = (props: any) => {
    const { customerId, guestId } = props;

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={GlobalTheme}>
                <ChangeGraphicColorDialogContainer
                    customerId={customerId}
                    guestId={guestId}
                />
            </MuiThemeProvider>
        </Provider>
    );
};

const ChangeGraphicColorDialogElement = document.getElementById(
    'kapinua-change-graphic-color-dialog'
);
if (ChangeGraphicColorDialogElement !== null) {
    ReactDOM.render(
        React.createElement(ChangeGraphicColorDialogComponent, {
            customerId: ChangeGraphicColorDialogElement.dataset.customeroverride
                ? Number(
                      ChangeGraphicColorDialogElement.dataset.customeroverride
                  )
                : null,
            guestId: ChangeGraphicColorDialogElement.dataset.guestoverride
                ? Number(ChangeGraphicColorDialogElement.dataset.guestoverride)
                : null,
        }),
        ChangeGraphicColorDialogElement
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
